import * as React from 'react'
import { cn } from '~/lib/utils'

// 미니멀 데이터 테이블 — 시맨틱 토큰만 사용. 작고 촘촘한 1px 보더 표.
function Table({ className, ...props }: React.ComponentProps<'table'>) {
    return (
        <div
            data-slot='table-container'
            className='border-border bg-card overflow-hidden overflow-x-auto rounded-[var(--radius)] border'>
            <table
                data-slot='table'
                className={cn('w-full text-[13px]', className)}
                {...props}
            />
        </div>
    )
}

function TableHeader({ className, ...props }: React.ComponentProps<'thead'>) {
    return (
        <thead
            data-slot='table-header'
            className={cn('bg-secondary border-border border-b', className)}
            {...props}
        />
    )
}

function TableBody({ className, ...props }: React.ComponentProps<'tbody'>) {
    return <tbody data-slot='table-body' className={className} {...props} />
}

function TableRow({ className, ...props }: React.ComponentProps<'tr'>) {
    return (
        <tr
            data-slot='table-row'
            className={cn(
                'border-border hover:bg-secondary/50 border-b transition-colors last:border-0',
                className
            )}
            {...props}
        />
    )
}

function TableHead({ className, ...props }: React.ComponentProps<'th'>) {
    return (
        <th
            scope='col'
            data-slot='table-head'
            className={cn(
                'admin-eyebrow border-border/60 border-r px-3 py-2 text-left whitespace-nowrap last:border-r-0',
                className
            )}
            {...props}
        />
    )
}

function TableCell({ className, ...props }: React.ComponentProps<'td'>) {
    return (
        <td
            data-slot='table-cell'
            className={cn(
                'tnum text-foreground border-border/60 border-r px-3 py-2 align-middle text-[13px] last:border-r-0',
                className
            )}
            {...props}
        />
    )
}

function TableCaption({
    className,
    ...props
}: React.ComponentProps<'caption'>) {
    return (
        <caption
            data-slot='table-caption'
            className={cn('text-muted-foreground mt-4 text-sm', className)}
            {...props}
        />
    )
}

export {
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
    TableCaption,
}
